import React, { useState } from 'react';
import { PageHeader, Page, PageContent, Box, Text, Tab, Tabs, Paragraph } from 'grommet';
import { DashboardGrid } from '../../components/DashboardGrid'; 
import { MapTabContent } from '../../components/MapTabContent';
import ProductLedHomeTilesCSV from '../../data/productled/ProductLedHomeTiles.csv';

// Import the texts JSON file
import ProductLedHomeTexts from '../../data/productled/ProductLedHomeTexts.json';

export const ProductLedHome = () => {
  const [activeHomeTab, setActiveHomeTab] = useState(0);

  // Destructure the data from the imported JSON
  const { pageHeader, tabs } = ProductLedHomeTexts;

  return (
    <Page flex="grow" background="background">
      <Box background={`url(${pageHeader.backgroundImage})`} height="140px" margin={{ top: 'none' }}>
        <Box margin={{ top: 'none', left: 'large' }}>
          <PageHeader
            pad={{ top: '5px', bottom: '10px' }}
            title={<Text color="white" size="xxlarge" weight="bolder" style={{ fontWeight: 'bold' }}>{pageHeader.title}</Text>}
            subtitle={pageHeader.subtitle}
            style={{ color: 'white' }}
            size="medium"
          />
        </Box>                  
      </Box> 

      <PageContent flex="grow">
        <Tabs activeIndex={activeHomeTab} onActive={setActiveHomeTab} justify="start" margin={{ top: 'medium' }}>
          {tabs.map((tab, index) => (
            <Tab key={index} title={tab.label}>
              {activeHomeTab === 0 ? (
                <DashboardGrid filePath={ProductLedHomeTilesCSV} />
              ) : (
                // For all other tabs, display "Coming soon..."
                <MapTabContent>
                  <Paragraph margin="none">Coming soon...</Paragraph>
                </MapTabContent>
              )}
            </Tab>
          ))}
        </Tabs>
      </PageContent>  
    </Page>
  );
};

